import { Component } from '@angular/core';
import { FeedbackPlatformReviewQuestionRubricEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Review Question Rubrics') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformreviewquestionrubric-form',
    templateUrl: './feedbackplatformreviewquestionrubric.form.component.html'
})
export class FeedbackPlatformReviewQuestionRubricFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformReviewQuestionRubricEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reviewResponses', sectionName: 'Review Responses', isExpanded: false }
        ]);
    }
}

